import { apiClient } from './client';
import { Contact, ContactsListParams, PaginatedResponse } from '../types';

export interface ContactCreateInput {
  company_id?: string;
  job_title?: string;
  is_primary_contact?: boolean;
  is_postempfaenger?: boolean;
  propstack_id?: string;
  salutation?: string;
  title?: string;
  first_name?: string;
  last_name?: string;
  display_name: string;
  email?: string;
  emails_all?: string;
  phone?: string;
  mobile_private?: string;
  phone_office?: string;
  mobile_office?: string;
  propstack_status?: string;
  propstack_tags?: string;
  last_contact_at?: string;
  is_blocked?: boolean;
}

export async function getContacts(params: ContactsListParams = {}): Promise<PaginatedResponse<Contact>> {
  const { data } = await apiClient.get<PaginatedResponse<Contact>>('/contacts', { params });
  return data;
}

export async function getContact(id: string): Promise<{ data: Contact }> {
  const { data } = await apiClient.get<{ data: Contact }>(`/contacts/${id}`);
  return data;
}

export async function createContact(input: ContactCreateInput): Promise<{ data: Contact }> {
  const { data } = await apiClient.post<{ data: Contact }>('/contacts', input);
  return data;
}

export async function updateContact(id: string, input: Partial<ContactCreateInput>): Promise<{ data: Contact }> {
  const { data } = await apiClient.put<{ data: Contact }>(`/contacts/${id}`, input);
  return data;
}

export async function deleteContact(id: string): Promise<void> {
  await apiClient.delete(`/contacts/${id}`);
}

export async function bulkDeleteContacts(ids: string[]): Promise<void> {
  await apiClient.delete('/contacts/bulk', { data: { ids } });
}
